import { colors, FelaCSS, FelaCSSWithCustomSelectors } from '@bridebook/ui';

interface IStyle {
  box: (isHidden: boolean) => FelaCSSWithCustomSelectors;
  boxHolder: (isHidden: boolean) => FelaCSS;
  logoBox: FelaCSS;
  text: FelaCSS;
  button: FelaCSS;
}

const style = (): IStyle => ({
  box: (isHidden) => ({
    position: 'fixed',
    top: 0,
    zIndex: 2000,
    width: '100%',
    height: 59,
    background: colors.indigoCrush,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    paddingHorizontal: 2,
    alignItems: 'center',
    gap: 8,
    flexDirection: 'row',
    color: colors.white,

    ...(isHidden && { height: 0, transition: '.3s height ease', overflow: 'hidden' }),

    '& svg': {
      flexShrink: 0,
      strokeWidth: 2,
    },
  }),
  boxHolder: (isHidden) => ({
    height: 59,

    ...(isHidden && { height: 0, transition: '.3s height ease' }),
  }),
  logoBox: {
    width: 40,
    height: 40,
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(180deg, #DBDCF9 0%, #FFF 100%)',
    borderRadius: 4,
  },
  text: {
    flexGrow: 1,
    fontDefaultSemiBold: 14,
    lineHeight: '150%',
  },
  button: {
    width: 'initial',
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
});

export default style;
